
import WebApp from '@twa-dev/sdk';

const BASE_URL = (import.meta.env.VITE_API_BASE_URL as string | undefined) ?? '';

export async function apiFetch<T>(path: string, options?: RequestInit): Promise<T> {
  const initData = WebApp.initData;
  const headers: Record<string, string> = {
    'Content-Type': 'application/json',
    ...(options?.headers as Record<string, string> | undefined),
  };
  // Authorization: tma <initDataRaw> per frozen contract
  if (initData) headers['Authorization'] = `tma ${initData}`;

  const res = await fetch(`${BASE_URL}${path}`, { ...options, headers });
  if (!res.ok) {
    const txt = await res.text().catch(() => res.statusText);
    throw new Error(`API ${res.status}: ${txt}`);
  }
  if (res.status === 204) return undefined as unknown as T;
  return res.json() as Promise<T>;
}
